import React from "react";
import "./KnowUs.css";

import celso from "../../assets/video/Mini video presentacion Celso.MOV";

const KnowUs = () => {
  return (
    <>
      <div className="knowus-k" id="knowus">
        <h2 className="title-k">Equipo</h2>
        <div className="grid-container-k">
          <div className="video-container">
            <video autoPlay muted loop className="video-k">
              <source src={celso} type="video/mp4" />
            </video>
          </div>
          <div className="text-k">
            <p className="profiletitle-k">
              Arquitecto <br />
              Celso Rodríguez
            </p>
            <p className="subtitle-k">
              Egresado de la Facultad de <br />
              Arquitectura, Diseño y Urbanismo - Año 2012
            </p>
            <p className="subtitle2-k">
              Docente de AUTOCAD en CoCap <br />
              Desde 2013 al 2024
            </p>
            <p className="subtitle2-k">Diseñador Gráfico</p>
            <p className="subtitle2-k">Técnico en Energias Renovables</p>
            <p className="subtitle2-k">
              Técnico en Sistema de gestión integrados IMSA - LSQA
            </p>
          </div>
        </div>
        <div className="second-grid-k">
          <div>
            <p className="sgprofiletitle-k">Contador</p>
            <p className="sgsubtitle-k">Agustín Berta</p>
          </div>
          <div>
            <p className="sgprofiletitle-k">Administración</p>
            <p className="sgsubtitle-k">Romina Fernández</p>
          </div>
          <div>
            <p className="sgprofiletitle-k">Arq. y Prevencionista</p>
            <p className="sgsubtitle-k"> Lina Rodríguez</p>
          </div>
          <div>
            <p className="sgprofiletitle-k">Ingeniería industrial</p>
            <p className="sgsubtitle-k">Isasa & Da Silva Ingenieros</p>
          </div>
          <div>
            <p className="sgprofiletitle-k">Dibujante Técnico</p>
            <p className="sgsubtitle-k">Marcelo Lapuente</p>
          </div>
          <div>
            <p className="sgprofiletitle-k">Electricidad</p>
            <p className="sgsubtitle-k">Juan Carlos Cruz</p>
          </div>
          <div>
            <p className="sgprofiletitle-k">Comunicación</p>
            <p className="sgsubtitle-k">Lic. Gimena Suárez</p>
          </div>
          <div>
            <p className="sgprofiletitle-k">Diseño Gráfico & Marketing</p>
            <p className="sgsubtitle-k">Lic. Lucía Pérez</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default KnowUs;
